import { MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MatDialogConfig } from '@angular/material/dialog';

export const matDialogDefaultOptions = {
  animationDuration: '10',
};

export const matFormFieldDefaultOptions: MatFormFieldDefaultOptions = {
  appearance: 'outline',
  floatLabel: 'always',
};

export const matDialogSlideInOptions: MatDialogConfig = {
  panelClass: ['dialog--slide-in'],
  maxWidth: '90vw',
  height: '100%',
};

export const matDialogSlideInTopOptions: MatDialogConfig = {
  ...matDialogSlideInOptions,
  height: 'auto',
  maxHeight: '90vh',
  width: '100%',
  maxWidth: '100%',
  panelClass: matDialogSlideInOptions.panelClass.concat('dialog--slide-in-top'),
  position: { top: '0', left: '0' },
};

export const matDialogSlideInRightOptions: MatDialogConfig = {
  ...matDialogSlideInOptions,
  panelClass: matDialogSlideInOptions.panelClass.concat(
    'dialog--slide-in-right'
  ),
  position: { top: '0', right: '0' },
};

export const matDialogSlideInLeftOptions: MatDialogConfig = {
  ...matDialogSlideInOptions,
  panelClass: matDialogSlideInOptions.panelClass.concat(
    'dialog--slide-in-left'
  ),
  position: { top: '0', left: '0' },
};
